module.exports = __webpack_public_path__ + "fonts/Gilroy-Bold.a64a9ab.otf";